import React from "react";
import ForgotPassword from '../../views/login/forgotPassword'

export default function Login() {
    return <ForgotPassword />
}